import api from '../config/api';
import { DashboardData } from '../types';

export const dashboardService = {
  getStats: async (): Promise<DashboardData> => {
    const res = await api.get('/api/dashboard');
    return res.data;
  },
};
